import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import Modal from "react-modal";

import { Link } from "react-scroll";

import { scroller } from "react-scroll";

import MenuDesktop from "./smallComponentes/MenuDesktop";
import SocialIcons from "./smallComponentes/SocialIcons";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [resumeOpen, setResumeOpen] = useState(false);
  function openModalResume() {
    setResumeOpen(true);
  }

  useEffect(() => {
    if (window.location.hash !== "") {
      var currentAnchor = window.location.hash;
      // Use the react-scroll package to scroll to the element with the matching id
      scroller.scrollTo(currentAnchor.slice(1), {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: -50, // Scrolls to element + 50 pixels above the target
      });
    }
  }, []);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const closeModalResume = () => {
    setResumeOpen(false);
  };

  const handleClick = () => setNav(!nav);
  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0f172a] text-gray-300 ">
      <div>
        <img
          src="./logo.png"
          alt=""
          className="w-[30px] h-[30px] md:w-[40px] md:h-[40px]"
        />
      </div>

      <MenuDesktop openModalResume={openModalResume} />
      {/* Hamburger */}
      <div className="z-10 md:hidden" onClick={handleClick}>
        {!nav ? <FaBars></FaBars> : <FaTimes />}
      </div>
      {/* Mobile menu */}
      {/* absolute top-0 left-0 w-full h-screen bg-[#0f172a] flex flex-col
      justify-center items-center" */}
      <ul
        className={
          !nav
            ? "hidden"
            : "absolute top-0 left-0 w-full h-screen bg-[#0f172a] flex flex-col justify-center items-center "
        }
      >
        <li className="py-6 text-4xl">
          <Link to="home" smooth={true} duration={500} onClick={handleClick}>
            Home
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link to="about" smooth={true} duration={500} onClick={handleClick}>
            About
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link to="skill" smooth={true} duration={500} onClick={handleClick}>
            Skills
          </Link>
        </li>
        <li className="py-6 text-4xl">
          {" "}
          <Link to="work" smooth={true} duration={500} onClick={handleClick}>
            Work
          </Link>
        </li>
        <li className="py-6 text-4xl">
          <Link to="contact" smooth={true} duration={500} onClick={handleClick}>
            Contact
          </Link>
        </li>
      </ul>
      {/* Social Icons */}

      <SocialIcons />
      <Modal
        isOpen={resumeOpen}
        // onAfterOpen={afterOpenResume}
        onRequestClose={closeModalResume}
        style={customStyles}
        contentLabel="Example Modal"
        // onClick={closeModalSecond}
      >
        <iframe
          src="./Ahmaddin_resume.pdf"
          loading="lazy"
          width="100%"
          height="auto"
          className="w-[80vw] h-screen max-w-6xl"
          title="resume"
        />
      </Modal>
    </div>
  );
}

export default Navbar;
